import React from 'react'
import ReactDOM from 'react-dom'
import './styles/main.scss'
import App from './App'
import 'bulma'


ReactDOM.render(
  <App />,
  document.getElementById('root')
)
